import { useMatches } from "react-router";
import { AnimatePresence, motion } from "framer-motion";
import { MdFeedback, MdKeyboardDoubleArrowUp } from "react-icons/md";
import useLocale from "~/hook/useLocale";
import { useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
type PropsType = {
  showTopButton: boolean;
  showFeedbackButton?: boolean;
};
const ScrollToTopButton = ({ showTopButton, showFeedbackButton = true }: PropsType) => {
  const matches = useMatches();
  const currentRouteId = matches[matches.length - 1].id;

  const isDisplayFeedbackButton = currentRouteId !== "routes/$lang.contact-us";
  const { currentAudio } = useAppSelector((state) => state.nityNiyam);
  const { navigate } = useLocale();
  return (
    <div className={cn("right-7 fixed z-10 flex flex-col gap-y-2", currentAudio ? "bottom-24 md:bottom-28 right-3 md:right-6" : "bottom-7")}>
      {showTopButton && (
        <AnimatePresence mode="wait">
          <motion.button
            key="scroll-to-top"
            initial={{ opacity: 0, scale: 0, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0, y: 20 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className={cn(
              "size-10 rounded-full flex flex-col items-center self-end justify-center  cursor-pointer z-10 bg-darkOrangeColor shadow-[0px_4px_46px_0px_rgba(114,52,25,0.20)] hover:shadow-xl transition-shadow duration-200",
            )}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Scroll to top"
          >
            <MdKeyboardDoubleArrowUp size={20} className="text-white" />
          </motion.button>
        </AnimatePresence>
      )}
      {isDisplayFeedbackButton && showFeedbackButton && (
        <AnimatePresence mode="wait">
          <div className="flex flex-row-reverse items-center gap-x-2">
            <motion.button
              key="feedback-button"
              initial={{ opacity: 0, scale: 0 }}
              animate={{
                opacity: 1,
                scale: 1,
                // y: showTopButton ? -10 : 0,
              }}
              exit={{ opacity: 0, scale: 0 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className={cn(
                "px-2.5 py-1.5 rounded-lg bg-gradient-to-r from-darkOrangeColor to-orange-500 flex items-center gap-1.5 shadow-md hover:shadow-lg transition-all duration-200 hover:from-orange-600 hover:to-orange-600",
              )}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Send feedback"
              onClick={() => {
                navigate(`/contact-us`);
              }}
            >
              <MdFeedback size={16} className="text-white" />
              <span className="text-white text-xs font-semibold">Feedback</span>
            </motion.button>
          </div>
        </AnimatePresence>
      )}
    </div>
  );
};

export default ScrollToTopButton;
